export enum ResponseAnswer {
  NoAttempt = 1,
  NeedsImprovement = 2,
  MeetsExpectations = 3,
  ExceedsExpectations = 4,
  NotApplicable = 5,
}
